import {棚卸差数在庫場所結果型, 棚卸差数棚卸年月日型, 棚卸差数検索依頼型, 棚卸差数結果型} from '@/type/inquire/item';
import {InventoryDiffApi} from '@/infrastructure/api/inquire/inventoryDiffApi';
import api from '@/infrastructure/api/api';
import download from '@/infrastructure/api/download';

export class StandardInventoryDiffApi implements InventoryDiffApi {

  async 棚卸差数在庫場所一覧を取得する(): Promise<棚卸差数在庫場所結果型> {
    return api.棚卸差数在庫場所一覧を取得する();
  }

  async 棚卸差数棚卸年月日一覧を取得する(部署コード: string): Promise<棚卸差数棚卸年月日型[]> {
    return api.棚卸差数棚卸年月日一覧を取得する(部署コード);
  }

  async 棚卸差数一覧を取得する(棚卸差数検索依頼: 棚卸差数検索依頼型): Promise<棚卸差数結果型> {
    return api.棚卸差数一覧を取得する(棚卸差数検索依頼);
  }

  async 棚卸差数一覧表を出力する(filename: string, 検索内容: {}): Promise<void> {
    return download.棚卸差数一覧表を出力する(filename, 検索内容);
  }
}
